export const defaultStyle = `
	label {
        font-weight: 600;
    }
`;
